import { defineComponent, useTemplateRef, useModel, ref, watch, toRaw, onMounted, nextTick, openBlock, createElementBlock, createBlock, unref, withCtx, renderSlot, Fragment, renderList, normalizeClass, toDisplayString, createCommentVNode, createVNode, mergeModels } from 'vue';
import '@ssml-editor/core';
import { Blank, BlankType } from '@ssml-editor/vue';
import { ElScrollbar } from 'element-plus';
/* empty css                                                                                                                                        */
/* empty css                                                                                                                                                */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "infinite-scroll",
  props: /* @__PURE__ */ mergeModels({
    pageSize: {},
    showNoMore: { type: Boolean, default: false },
    load: { type: Function, default: () => [] }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const scrollbarRef = useTemplateRef("scrollbar");
    const model = useModel(__props, "modelValue");
    const emit = __emit;
    const loadingShowed = ref(false);
    const noMoreShowed = ref(false);
    const selectedItem = ref();
    const dataList = ref([]);
    const page = ref(1);
    async function scrollLoad(direction) {
      if (direction === "bottom") {
        if (!loadingShowed.value && !noMoreShowed.value) {
          loadingShowed.value = true;
          const result = await __props.load(page.value);
          loadingShowed.value = false;
          if (result.length > 0) {
            dataList.value = [...dataList.value, ...result];
            if (__props.pageSize && __props.pageSize > 0) {
              if (result.length < __props.pageSize) {
                noMoreShowed.value = true;
              } else {
                page.value += 1;
              }
            } else {
              page.value += 1;
            }
          } else {
            noMoreShowed.value = true;
          }
        }
      }
    }
    function selectHandler(item) {
      selectedItem.value = item;
      model.value = item.value;
    }
    function scrollIntoView() {
      if (scrollbarRef.value && dataList.value.length > 0) {
        for (let i = 0; i < dataList.value.length; i++) {
          if (dataList.value[i].value === model.value) {
            if (scrollbarRef.value.wrapRef && scrollbarRef.value.wrapRef.children.length > 0) {
              const wrapElement = scrollbarRef.value.wrapRef.children[0];
              const elements = wrapElement.children;
              scrollbarRef.value.scrollTo({
                top: elements[i].getBoundingClientRect().top - wrapElement.getBoundingClientRect().top
              });
            }
            return;
          }
        }
      }
    }
    function getSelectedItem() {
      return selectedItem.value;
    }
    watch(
      dataList,
      (newValue) => {
        emit("change", toRaw(newValue));
      },
      {
        deep: true,
        immediate: true
      }
    );
    onMounted(async () => {
      await scrollLoad("bottom");
      nextTick(() => {
        scrollIntoView();
      });
    });
    __expose({
      getSelectedItem
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-infinite-scrollbar" }, [
        dataList.value.length > 0 ? (openBlock(), createBlock(unref(ElScrollbar), {
          key: 0,
          ref: "scrollbar",
          native: "",
          "wrap-class": "se-scrollbar-wrap",
          distance: 1,
          onEndReached: scrollLoad
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {
              model: model.value,
              dataList: dataList.value
            }, () => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(dataList.value, (item, index) => {
                return openBlock(), createElementBlock("p", {
                  class: normalizeClass(["se-item", { activated: item.value === model.value }]),
                  title: item.label,
                  key: index,
                  onClick: ($event) => selectHandler(item)
                }, toDisplayString(item.label), 11, ["title", "onClick"]);
              }), 128))
            ], true),
            loadingShowed.value ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "se-loading"
            }, "Loading...")) : createCommentVNode("", true),
            dataList.value.length > 0 && __props.showNoMore && noMoreShowed.value ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "se-no-more"
            }, " - No more - ")) : createCommentVNode("", true)
          ]),
          _: 3
        }, 512)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: "se-blank"
        }, [
          createVNode(unref(Blank), {
            type: unref(BlankType).LIST
          }, null, 8, ["type"])
        ]))
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=infinite-scroll.vue2.js.map
